<template>
  <div
    v-if="value"
    class="price-info"
    :class="{ 'price-info--reduction': value.old }"
    :aria-label="t('checkout.basket.position.header.price') + ' ' + value.current"
  >
    <div
      class="price-info__old"
      v-if="value.old"
    >
      <span class="price-info__old-text">{{ t('price.instead_of') }}</span>
      <span class="price-info__old-value">
        <span class="price-info__old-value-currency">{{ value.currency }}</span>
        <span class="price-info__old-value-price">{{ oldValue }}</span>
      </span>
    </div>

    <div class="price-info__current">
      <span class="price-info__currency">{{ value.currency }}</span>
      <span class="price-info__value">{{ value.currentValue }}</span>
      <span
        v-if="showStar"
        class="price-info__asterisk"
      >*</span>
      <span
        class="price-info__savedPercentage price-info--savings-max"
        v-if="value.savedPercentage && withSavingsMax && value.savedPercentage > 50"
        v-html="t('product.price.savedPercentage.savingsMax')"
      />
      <span
        class="price-info__savedPercentage"
        v-else-if="value.savedPercentage"
      >
        -{{ value.savedPercentage }}%
      </span>
    </div>

    <div class="price-info__unit-wrapper">
      <div class="price-info__unit">
        <span class="price-info__unit-text">{{ getUnitText() }}</span>
        <span
          v-if="value.unitPrice"
          class="price-info__unit-price"
        >
          {{ value.unitPrice }}<template v-if="value.unit">/{{ value.unit }}</template>
        </span>
      </div>
      <div
        v-if="showTax"
        class="price-info__tax"
        v-html="t(showShippingIncluded ? messageKey.deliveryInclShip : messageKey.deliveryInclVat, [shippingInfoUrl])"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from 'vue';
  import type Price from '../../../bps/types/Price';
  import {t} from '../../../bps/utilities/js/translations/translations';

  interface Props {
    value: Price;
    showTax?: boolean;
    showShippingIncluded?: boolean;
    shippingInfoUrl?: string;
    withSavingsMax?: boolean;
    textSize?: 'short' | 'normal';
  }

  const props = withDefaults(defineProps<Props>(), {
    value: null,
    showTax: true,
    shippingInfoUrl: '',
    showShippingIncluded: false,
    withSavingsMax: false,
    textSize: 'short',
  });

  const showStar = ref(false);

  const messageKey: {[key: string]: any} = ref({
    deliveryInclShip: 'price.incl_vat_incl_ship',
    deliveryInclVat: 'price.incl_vat',
  });

  if (window.__productConfig && window.__productConfig.messageKey) {
    messageKey.value = window.__productConfig.messageKey;
  }

  const oldValue = computed(() =>
    props.value.old ? props.value.old.replace(/[ €]/g, '') : null
  );

  function getUnitText() {
    if (props.textSize === 'short') {
      return getShortUnitText();
    }
    let result = t(`product.price.volumeUnit.${props.value.volumeUnit}`);
    if (props.value.unitPrice) {
      if (props.value.packageSize) {
        result += ' (' + props.value.packageSize + ')';
      }
      result += ',';
    }
    return result;
  }

  function getShortUnitText() {
    let result = '';
    if (props.value.unitPrice) {
      if (props.value.packageSize) {
        result += props.value.packageSize;
      }
      result += ',';
    }
    return result;
  }
</script>
